import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  href?: string;
  className?: string;
  onClick?: () => void;
}
export function CTAButton({
  children,
  href,
  className = '',
  onClick
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
    if (onClick) {
      onClick();
    } else if (!href || href.startsWith('#')) {
      e.preventDefault();
      const targetId = href ? href.substring(1) : 'pricing';
      const element = document.getElementById(targetId);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  const baseClasses = `
    relative inline-flex items-center justify-center w-full
    px-5 py-4 sm:px-6 sm:py-5
    bg-swiss-green-cta hover:bg-[#218838]
    text-white font-bold text-base sm:text-lg uppercase tracking-wide
    rounded-xl shadow-md hover:shadow-lg hover:-translate-y-0.5
    transition-all duration-200
    ${className}
  `;
  const content = <span className="relative z-10 flex items-center text-center justify-center gap-2 leading-tight" data-id="element-37">
      <span data-id="element-38">{children}</span>
    </span>;
  if (href && !href.startsWith('#')) {
    return <a href={href} className={baseClasses} onClick={handleClick} target={href.startsWith('http') ? '_self' : '_self'} data-id="element-39">
        {content}
      </a>;
  }
  return <button className={baseClasses} onClick={handleClick} data-id="element-40">
      {content}
    </button>;
}